import { render, staticRenderFns } from "./formStudentActivity.vue?vue&type=template&id=0e6974d4&scoped=true&"
import script from "./formStudentActivity.vue?vue&type=script&lang=js&"
export * from "./formStudentActivity.vue?vue&type=script&lang=js&"
import style0 from "./formStudentActivity.vue?vue&type=style&index=0&id=0e6974d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6974d4",
  null
  
)

export default component.exports